/**
 * Text utility functions for search functionality.
 */

/**
 * Escape HTML entities to prevent XSS attacks.
 * @param {string} text - The text to escape
 * @returns {string} Escaped text with HTML entities encoded
 */
export function escapeHtml(text) {
  if (typeof text !== 'string') return '';

  const map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  };

  return text.replace(/[&<>"']/g, (char) => map[char]);
}

/**
 * Highlight search term in text (case-insensitive).
 * Escapes HTML in both text and searchTerm before processing.
 * @param {string} text - The text to search in
 * @param {string} searchTerm - The term to highlight
 * @returns {string} Text with search term wrapped in <mark> tags (HTML-safe)
 */
export function highlightSearchTerm(text, searchTerm) {
  if (!text || !searchTerm) return escapeHtml(text || '');

  // Escape both inputs to prevent XSS
  const escapedText = escapeHtml(text);
  const escapedSearchTerm = escapeHtml(searchTerm);

  const textLower = escapedText.toLowerCase();
  const searchLower = escapedSearchTerm.toLowerCase();
  const index = textLower.indexOf(searchLower);

  if (index === -1) return escapedText;

  const before = escapedText.slice(0, index);
  const match = escapedText.slice(index, index + escapedSearchTerm.length);
  const after = escapedText.slice(index + escapedSearchTerm.length);

  return `${before}<mark>${match}</mark>${after}`;
}

